import React from 'react';
import { formatDate } from '../../utils/helpers';

const BlogDetailModal = ({ blog, isOpen, onClose }) => {
    if (!isOpen || !blog) return null;

    // Format content with paragraphs
    const formatContent = (content) => {
        if (!content) return '';
        return content.split('\n').map((paragraph, index) => (
            <p key={index} className="mb-4 text-gray-700 leading-relaxed">
                {paragraph}
            </p>
        ));
    };

    return (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4" onClick={onClose}>
            <div className="bg-white rounded-xl max-w-3xl w-full max-h-[90vh] overflow-y-auto relative animate-fadeIn" onClick={(e) => e.stopPropagation()}>
                <button 
                    onClick={onClose} 
                    className="sticky top-0 float-right m-4 z-10 bg-white rounded-full w-8 h-8 flex items-center justify-center shadow-md text-gray-400 hover:text-gray-600 transition-all"
                >
                    <i className="fas fa-times"></i>
                </button>
                
                <div className="p-6 pt-0">
                    {/* Header Section */}
                    <div className="border-b border-gray-200 pb-6 mb-6">
                        <div className="w-16 h-16 bg-gradient-to-r from-gradpath-green to-gradpath-dark rounded-2xl flex items-center justify-center mb-4">
                            <i className="fas fa-newspaper text-white text-2xl"></i>
                        </div>
                        
                        <h2 className="text-2xl md:text-3xl font-bold text-gradpath-dark mb-4">
                            {blog.title}
                        </h2>
                        
                        <div className="flex flex-wrap gap-4 text-sm text-gray-500">
                            <span className="inline-flex items-center gap-2">
                                <i className="fas fa-user text-gradpath-green"></i>
                                <span className="font-medium text-gray-700">{blog.author}</span>
                            </span>
                            <span className="inline-flex items-center gap-2">
                                <i className="fas fa-calendar-alt text-gradpath-green"></i>
                                <span>{formatDate(blog.createdAt)}</span>
                            </span>
                            {blog.updatedAt && blog.updatedAt !== blog.createdAt && (
                                <span className="inline-flex items-center gap-2">
                                    <i className="fas fa-edit text-gradpath-green"></i>
                                    <span>Updated: {formatDate(blog.updatedAt)}</span>
                                </span>
                            )}
                        </div>
                    </div>
                    
                    {/* Tagline */}
                    {blog.tagline && (
                        <div className="bg-gray-50 border-l-4 border-gradpath-green p-4 mb-6 rounded-r-lg">
                            <p className="text-gray-700 italic">
                                "{blog.tagline}"
                            </p>
                        </div>
                    )}
                    
                    {/* Full Content */}
                    <div className="prose prose-green max-w-none">
                        {formatContent(blog.content)}
                    </div>
                    
                    {/* Footer */}
                    <div className="border-t border-gray-200 mt-8 pt-6">
                        <div className="flex items-center justify-between flex-wrap gap-4">
                            <div className="flex items-center gap-2 text-sm text-gray-500">
                                <i className="fas fa-tag text-gradpath-green"></i>
                                <span>Career Advice</span>
                            </div>
                            <button
                                onClick={onClose}
                                className="px-4 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition-all"
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BlogDetailModal;